import { MultipleSelectQuestionSpec } from '@/model/question/multipleSelect'

export class DoubleDownQuestionSpec extends MultipleSelectQuestionSpec {
  get playerAnswerCount (): number {
    return 2
  }
}
